<template>
  <div class="login" @click="() => $listeners.onOff(false)">
    <div class="pop_up_window_content" @click.stop="() => null">
      <div class="left_img">
        <div class="header">
          <img :src="require('@/assets/images/public/login_background.png')">
        </div>
        <div class="text_content">{{ t('login.intro') }}</div>
      </div>
      <div class="right_form">
        <LoginForm v-if="$store.state.loginStatus" />
        <SignForm v-if="!$store.state.loginStatus" />
      </div>
    </div>
  </div>
</template>

<script>
import { t } from '@/locales';
import LoginForm from './loginForm';
import SignForm from './signForm';
export default {
  components: { LoginForm, SignForm },
  props: {
    submit: { type: Function, }
  },
  methods: { t },
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
